<script>
  import {supabase} from "../routes/api/supabase.js"
  import {goto} from "$app/navigation"
  import AuthForm from "./AuthForm.svelte"

  let loading = false

  const handleSignUp = async (email, password) => {
    try {
      loading = true

      const { user, session, error } = await supabase.auth.signUp({email, password}) // eslint-disable-line no-unused-vars

      if (error) {
	throw error
      }

      await alert('Check your email for a confirmation link!')
      goto("/")
    }
    catch (error) {
      alert(error.error_description || error.message)
    }
    finally {
      loading = false
    }
  }
</script>


<AuthForm handler={handleSignUp} loading={loading} signup={true} />
